import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { profileAPI } from '../../../api'
import { userData } from 'features/user/store'
import {
  PROFILE_STUDENT_UPDATE_REQUEST,
  PROFILE_STUDENT_UPDATE_SUCCESS,
  PROFILE_STUDENT_UPDATE_FAILED,
} from './actionTypes'

export const profileStudentUpdatePA = createPromiseAction(
  PROFILE_STUDENT_UPDATE_REQUEST,
  PROFILE_STUDENT_UPDATE_SUCCESS,
  PROFILE_STUDENT_UPDATE_FAILED
)()

function* update(action) {
  try {
    const response = yield call(profileAPI.updateStudentProfile, action.payload)
    const { data } = response

    yield put(profileStudentUpdatePA.success({}))

    yield put(userData.updateData(data?.data))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* updateSaga() {
  yield takeEvery(profileStudentUpdatePA.request, update)
}
